import { sendRequest } from "../request";
const BASE_URL = '/api/trademarkApplications';

export function createTrademarkApplication(data) {
    return sendRequest(`${BASE_URL}/createTrademarkApplication`, 'POST', data, 'Unable to create trademark application');
}

export function getTrademarkApplications(user) {
    return sendRequest(`${BASE_URL}/getTrademarkApplications/${user._id}`);
}

export function getClientTrademarkApplications(user, clientID) {
    return sendRequest(`${BASE_URL}/getClientTrademarkApplications/${user._id}/${clientID}`);
}

export function updateTrademarkApplication(applicationID, data) {
    return sendRequest(`${BASE_URL}/updateTrademarkApplication/${applicationID}`, 'PUT', data, 'Unable to update trademark application');
}

export function getTrademarkApplication(applicationID){
    return sendRequest(`${BASE_URL}/getTrademarkApplication/${applicationID}`)
}

export function deleteTrademarkApplication(applicationID) {
    return sendRequest(`${BASE_URL}/deleteTrademarkApplication/${applicationID}`, 'DELETE', {}, 'Unable to delete trademark application');
}

export function findTrademarkApplications(user, searchQuery) {
    return sendRequest(`${BASE_URL}/findTrademarkApplications/${user._id}/${searchQuery}`);
}